var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.5C4.55228 3.5 5 3.05228 5 2.5C5 1.94772 4.55228 1.5 4 1.5C3.44772 1.5 3 1.94772 3 2.5C3 3.05228 3.44772 3.5 4 3.5Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5C8 3.05228 7.55228 3.5 7 3.5C6.44772 3.5 6 3.05228 6 2.5C6 1.94772 6.44772 1.5 7 1.5C7.55228 1.5 8 1.94772 8 2.5Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14V5.75H18V14C18 16.2091 16.2091 18 14 18H4C1.79086 18 0 16.2091 0 14Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0H4C1.79086 0 0 1.79086 0 4V4.25H18V4C18 1.79086 16.2091 0 14 0ZM5 2.5C5 3.05228 4.55228 3.5 4 3.5C3.44772 3.5 3 3.05228 3 2.5C3 1.94772 3.44772 1.5 4 1.5C4.55228 1.5 5 1.94772 5 2.5ZM7 3.5C7.55228 3.5 8 3.05228 8 2.5C8 1.94772 7.55228 1.5 7 1.5C6.44772 1.5 6 1.94772 6 2.5C6 3.05228 6.44772 3.5 7 3.5Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a61822d8174a545a793806e77bb2a684.svg";
export { ForwardRef as ReactComponent };